import React from "react";

export const Image = ({ title, largeImage, smallImage, url1 }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={url1} title={title} data-lightbox-gallery="gallery1" target="_blank" rel="noreferrer">
          <div className="hover-text">
            <h4>View More</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} style={{borderBottomLeftRadius: 15,
            borderBottomRightRadius: 15,
            borderTopRightRadius: 15,
            borderTopLeftRadius: 15}}/>{" "}
        </a>{" "}
      </div>
    </div>
  );
};
